import { polygonAreaM2 } from "./samplingDesign";
import {
  decileZonesFromLabels,
  defaultZoneTarget,
  reduceDecileZones,
  smoothDecilePatches,
  type BehaviorDrivers,
} from "./behaviorZones";
import type { ZoneGeom } from "./zoneDesign";

// The acres÷22 default, counted from the classified cells only. Null means "do not reduce":
// the stepper expresses that as an empty target, and the caller leaves zoneTarget alone.
export function behaviorZoneTarget(
  labels: number[],
  areaAcres: number,
): number | null {
  const distinct = new Set(labels.filter((l) => l >= 0)).size;
  return defaultZoneTarget(areaAcres, distinct);
}

// Reduce, then smooth, then dissolve. The reducer always starts from the full-resolution
// labels, so 40 → 30 → 40 matches a fresh 40. Smoothing runs last, and `shown` is what the
// pixels color from.
export function dissolveBehaviorZones(input: {
  geoms: { type: string; coordinates: unknown }[];
  geom: ZoneGeom;
  labels: number[];
  drivers: BehaviorDrivers;
  zoneTarget: number | null;
}): {
  shown: number[];
  fc: GeoJSON.FeatureCollection;
  labelPoints: { zone: number; code: string; lng: number; lat: number }[];
} {
  const reduced =
    input.zoneTarget != null
      ? reduceDecileZones(input.labels, input.drivers, input.zoneTarget)
      : input.labels;
  const first = input.geom.ringsPerCell[0]?.[0];
  const cellAreaM2 = first
    ? polygonAreaM2({
        type: "Polygon",
        coordinates: [[...first, first[0]]],
      })
    : 64;
  const shown = smoothDecilePatches(reduced, input.geom.adj, cellAreaM2);
  const out = decileZonesFromLabels(input.geoms, shown, input.drivers, {
    geom: input.geom,
  });
  return { shown, fc: out.fc, labelPoints: out.labelPoints };
}
